import { cva, type VariantProps } from 'class-variance-authority';

export const interactiveControl = [
  'inline-flex min-h-[var(--litopia-component-control-min-target)] items-center justify-center gap-[var(--litopia-component-control-content-gap)] whitespace-nowrap rounded-[var(--litopia-component-control-radius)] px-[var(--litopia-component-control-padding-inline)] py-[var(--litopia-component-control-padding-block)] text-sm font-medium',
  'transition-[color,background-color,border-color,box-shadow,transform,opacity]',
  'duration-quick ease-out',
  'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[hsl(var(--opp-accent))] focus-visible:ring-offset-2',
  'active:scale-[var(--litopia-component-button-press-scale)]',
  'disabled:pointer-events-none disabled:opacity-50',
  'motion-reduce:transform-none motion-reduce:transition-none',
].join(' ');

export const fieldControl = [
  'min-h-[var(--litopia-component-field-min-height)] rounded-[var(--litopia-component-control-radius)] px-[var(--litopia-component-control-padding-inline)] py-[var(--litopia-component-control-padding-block)]',
  'transition-[color,background-color,border-color,box-shadow]',
  'duration-quick ease-out',
  'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[hsl(var(--opp-accent))] focus-visible:ring-offset-2',
  'disabled:cursor-not-allowed disabled:opacity-50',
  'motion-reduce:transition-none',
].join(' ');

/**
 * Single visual contract for interactive controls. Both `<OppButton>` and
 * link-styled navigation reuse `buttonVariants` so a "primary action" always
 * resolves through the same OPP semantic tokens instead of per-page classes.
 */
export const buttonVariants = cva(interactiveControl, {
  variants: {
    variant: {
      primary:
        'bg-[hsl(var(--opp-accent))] text-[hsl(var(--opp-accent-foreground))] shadow-sm hover:bg-[hsl(var(--opp-accent-hover))]',
      secondary:
        'border border-[hsl(var(--opp-border))] bg-[hsl(var(--opp-surface-raised))] text-[hsl(var(--opp-ink))] hover:bg-[hsl(var(--opp-accent-soft))]',
      outline:
        'border-2 border-[hsl(var(--opp-border))] text-[hsl(var(--opp-accent-strong))] hover:bg-[hsl(var(--opp-surface-raised))]',
      ghost:
        'text-[hsl(var(--opp-accent-strong))] hover:bg-[hsl(var(--opp-accent-soft))]',
      danger:
        'bg-[hsl(var(--opp-danger-fg))] text-[hsl(var(--opp-danger-bg))] hover:opacity-90',
    },
    size: {
      sm: 'min-h-9 px-3 py-1.5 text-xs',
      md: 'min-h-11 px-4 py-2 text-sm',
      lg: 'min-h-12 px-6 py-3 text-base',
      icon: 'min-h-11 min-w-11 p-0',
    },
  },
  defaultVariants: {},
});

export type OppButtonVariantProps = VariantProps<typeof buttonVariants>;
